import { IaDatabaseActionTypesEnum } from '$ops-portal/context/ia-database-context/iaDatabase.types';
import { SECTION_LIST } from '@dfg/brahma-types';
import type { IAInfoDatabaseAction, IADatabaseInfo } from './iaInfo.types';

export const iaInfoReducer = (
  state: IADatabaseInfo,
  action: IAInfoDatabaseAction
): IADatabaseInfo => {
  switch (action.type) {
    case IaDatabaseActionTypesEnum.updateIaInfo:
      return {
        ...state,
        [action.payload.id]: {
          ...(state?.[action.payload.id] ?? {}),
          [SECTION_LIST.IA_BASIC_INFORMATION_ID]: {
            data: action.payload.data.basicInformation,
            isFetched: true,
            key: SECTION_LIST.IA_BASIC_INFORMATION_ID
          },
          [SECTION_LIST.IA_KNOWN_PAST_NAMES_ID]: {
            data: action.payload.data.knownPastNames,
            isFetched: true,
            key: SECTION_LIST.IA_KNOWN_PAST_NAMES_ID
          },
          [SECTION_LIST.IA_SYNONYMS_ID]: {
            data: action.payload.data.synonyms,
            isFetched: true,
            key: SECTION_LIST.IA_SYNONYMS_ID
          },
          [SECTION_LIST.IA_TRANSLATIONS_ID]: {
            data: action.payload.data.translations,
            isFetched: true,
            key: SECTION_LIST.IA_TRANSLATIONS_ID
          },
          ...(action.payload.data.isPartialVTUpdateAllowed !== undefined && {
            isPartialVTUpdateAllowed:
              action.payload.data.isPartialVTUpdateAllowed
          })
        }
      };
    case IaDatabaseActionTypesEnum.updateIaOffices: {
      let localState = { ...state };
      let { id, data } = action.payload;
      Object.entries(data ?? {}).forEach(([key, value]) => {
        localState = {
          ...localState,
          [id]: {
            ...(localState?.[id] ?? {}),
            offices: {
              ...(localState?.[id]?.offices ?? {}),
              data: {
                ...(localState?.[id]?.offices?.data ?? {}),
                [key]: {
                  ...(localState?.[id]?.offices?.data?.[key] ?? {}),
                  ...value
                }
              },
              isFetched: true
            }
          }
        };
      });

      return {
        ...localState
      };
    }
    case IaDatabaseActionTypesEnum.updateParticularIaOffice: {
      let localState = { ...state };
      let { id, data } = action.payload;
      Object.entries(data ?? {}).forEach(([key, value]) => {
        localState = {
          ...localState,
          [id]: {
            ...(localState?.[id] ?? {}),
            offices: {
              ...(localState?.[id]?.offices ?? {}),
              data: {
                ...(localState?.[id]?.offices?.data ?? {}),
                [key]: {
                  ...(localState?.[id]?.offices?.data?.[key] ?? {}),
                  ...value
                }
              }
            }
          }
        };
      });
      return {
        ...localState
      };
    }
    case IaDatabaseActionTypesEnum.updateIaOfficeEntities: {
      let localState = { ...state };
      let { issuingAuthorityId, issuingAuthorityOfficeId, data } =
        action.payload;
      Object.entries(data ?? {}).forEach(([key, value]) => {
        localState = {
          ...localState,
          [issuingAuthorityId]: {
            ...(localState?.[issuingAuthorityId] ?? {}),
            offices: {
              ...(localState?.[issuingAuthorityId]?.offices ?? {}),
              data: {
                ...(localState?.[issuingAuthorityId]?.offices?.data ?? {}),
                [issuingAuthorityOfficeId]: {
                  ...(localState?.[issuingAuthorityId]?.offices?.data?.[
                    issuingAuthorityOfficeId
                  ] ?? {}),
                  [key]: {
                    data: value,
                    key,
                    isFetched: true
                  }
                }
              }
            }
          }
        };
      });
      return { ...localState };
    }

    case IaDatabaseActionTypesEnum.updateIaOfficeModalInfo: {
      let localState = { ...state };
      let { issuingAuthorityId, issuingAuthorityOfficeId, data } =
        action.payload;
      localState = {
        ...localState,
        [issuingAuthorityId]: {
          ...(localState?.[issuingAuthorityId] ?? {}),
          offices: {
            ...(localState?.[issuingAuthorityId]?.offices ?? {}),
            data: {
              ...(localState?.[issuingAuthorityId]?.offices?.data ?? {}),
              [issuingAuthorityOfficeId]: {
                ...(localState?.[issuingAuthorityId]?.offices?.data?.[
                  issuingAuthorityOfficeId
                ] ?? {}),
                modalInfo: {
                  ...(
                    localState?.[issuingAuthorityId]?.offices?.data?.[
                      issuingAuthorityOfficeId
                    ] ?? {}
                  ).modalInfo,
                  ...data
                }
              }
            }
          }
        }
      };
      return { ...localState };
    }
    default:
      return state;
  }
};
